import dayjs from 'dayjs';
import Permission from '../enums/Permission';

export default class UserType {
  constructor(data) {
    this.id = data?.id;
    this.organizationId = data?.organizationId;
    this.name = data?.name;
    this.permissions = data?.permissions ? Permission.ofArray(data.permissions) : [];
    this.managesAllDepartments = data?.managesAllDepartments;
    this.createdAt = data?.createdAt ? dayjs(data.createdAt) : null;
    this.updatedAt = data?.updatedAt ? dayjs(data.updatedAt) : null;
  }
}
